import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { FiMenu } from "../../components/Icons";
import { logo } from '../../components/Images';
import MenuItem from './MenuItem';

export default function MobileMenu() {
    const [openMenu, setOpenMenu] = useState(false);
    return (
        <div className={`fixed top-0 right-0 left-0 z-[1000] lg:static ${openMenu === true ? `h-full overflow-y-auto overflow-x-hidden` : `h-auto`}`}>
            <div className={'relative sticky top-0 flex flex-col lg:hidden bg-secondary text-white z-[10000] '}>
                <div className={'flex flex-row drop-shadow-xl justify-between items-center p-6 pl-10 w-full'}>
                    <Link onClick={() => setOpenMenu(false)} to='/'><img src={logo} alt={'logo'} className=' w-20 object-contain' /></Link>
                    <FiMenu className='cursor-pointer' onClick={() => setOpenMenu(!openMenu)} />
                </div>
            </div>
            {
                openMenu && (
                    <div className={'lg:hidden'}>
                        <MenuItem type={'mobile'} closeMenu={() => setOpenMenu(!openMenu)} />
                    </div>
                )
            }
        </div>
    )
}